import { Checkbox, FormControlLabel } from '@material-ui/core';
import React from 'react';
import { IListItem } from '../../../../../contexts/filter/FiltersProvider';

interface IItem {
  handleCheckItem?: (label: string) => void;
  item: IListItem;
  styles: any;
  toggleItem: (label: string) => void;
}

const Item: React.FC<IItem> = ({ item, toggleItem, styles }) => {
  return (
    <FormControlLabel
      className={styles.item}
      control={
        <Checkbox
          color="primary"
          checked={item.checked}
          onChange={() => toggleItem(item.label)}
          className={styles.elementCheckbox}
        />
      }
      label={item.label}
    />
  );
};

export default Item;
